// extracted by mini-css-extract-plugin
module.exports = {"blocked":"AnimalStatus_blocked__1fr_M"};